import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';

type Props = {
  title: string;
  onBack: () => void;
  onClose: () => void;
};

export const PrimaryViewHeader = ({ title, onBack, onClose }: Props) => {
  return (
    <header css={headerStyles}>
      <div css={headerLeftStyles}>
        <Button
          iconName='back'
          variant='secondary'
          size='small'
          onClick={onBack}
          css={{ svg: { color: theme.colors.neutral90 } }}
        />
        <Text weight='bold'>{title}</Text>
      </div>
      <Button iconName='x' variant='secondary' onClick={onClose} />
    </header>
  );
};

const headerStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(1.5, 2),
});

const headerLeftStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
});
